<script>
  import {
    activeWorkshop,
    lessons,
    modules,
    currentLessonIndex,
    pageToLoad,
    highestLessonIndex,
    appMode,
  } from "../scripts/stores.js";
  import {
    populateLessonsAndModules,
    updateHighestLessonIndex,
  } from "../scripts/lessons.js";

  const openLesson = (index) => {
    currentLessonIndex.set(index);
    pageToLoad.set("lessonWrapper");
  };

  console.log("inside workshopHome");

  $: console.log($appMode);
  $: console.log($highestLessonIndex);

  $: $lessons & updateHighestLessonIndex();

  // $: $activeWorkshop.modules &&
  //     populateLessonsAndModules($activeWorkshop.modules);

  $: console.log($modules);

  const checkbox = {
    empty: "./images/checkbox-empty-icon.svg",
    full: "./images/checkbox-full-icon.svg",
  };
</script>

<main class="page">
  <h1>{$activeWorkshop.title}</h1>
  {#if $highestLessonIndex == -1}
    <div class="button-primary" on:click={() => openLesson(0)}>Begin</div>
  {:else}
    <div
      class="button-primary"
      on:click={() => openLesson($highestLessonIndex + 1)}
    >
      Resume
    </div>
  {/if}

  {#if !$modules}
    Loading...
  {:else}
    {#each $modules as module}
      <h2>{module.title}</h2>
      <p>Status: {module.isComplete ? "Complete" : "Incomplete"}</p>
      {#each module.lessons as lesson, i}
        <div class="info-row">
          <div class="mini-icon">
            <img
              src={lesson.isComplete ? checkbox.full : checkbox.empty}
              alt={lesson.isComplete ? "Complete" : "Incomplete"}
              width="15px"
            />
          </div>
          <span
            class="link-internal"
            on:click={() => openLesson(lesson.lessonIndex)}>{lesson.title}</span
          >
        </div>
      {/each}
    {/each}
  {/if}
</main>

<style>
  .info-row {
    display: flex;
    align-items: center;
    padding-top: 4px;
    padding-bottom: 4px;
  }
  .mini-icon {
    display: inline-flex;
    margin-right: 5px;
  }
  h1 {
    text-align: center;
  }
</style>
